module.exports = __webpack_public_path__ + "img/clip.044d0181.png";